import React from 'react';
import styles from './Spinner.module.css';

/**
 * `inline` muestra solo el anillo (sin padding ni texto) para usarlo dentro de
 * botones u otros controles; en ese caso es decorativo (aria-hidden).
 */
export default function Spinner({ size = 'md', label = 'Cargando…', inline = false }) {
  if (inline) {
    return <span className={`${styles.spinner} ${styles[size]}`} aria-hidden="true" />;
  }
  return (
    <div className={styles.wrap} role="status" aria-live="polite" aria-label={label}>
      <div className={`${styles.spinner} ${styles[size]}`} />
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
}
